// common/secret.js
import CryptoJS from 'crypto-js';
class SecretManager {
	constructor() {
		// 使用多种方式组合密钥，增加破解难度
		this._keyPart1 = this._reverseString('1+e1Bv+fVXtC');
		this._keyPart2 = this._reverseString('V7ytr8usNQ==');
	}

	generateSignature(data) {
		const hash = CryptoJS.HmacSHA256(data, this._reverseString(this._keyPart1) + this._reverseString(this
			._keyPart2));
		return CryptoJS.enc.Base64.stringify(hash);
	}

	// 字符串反转
	_reverseString(str) {
		return str.split('').reverse().join('');
	}
	// 获取完整密钥（运行时组合）
	getSecretKey(tel, scene) {
		// 测试
		let timestamp = Math.floor(Date.now() / 1000);
		let str = "tel=" + tel + "&timestamp=" + timestamp + "&scene=" + scene
		return {
			sign: this.generateSignature(str),
			timestamp
		}
	}
}

export default new SecretManager();